import React from 'react';
import PropTypes from 'prop-types';

import { ArrowRight } from '../Icons';
import ScrollButton from '../ScrollButton';
import { LETTER_FROM_THE_PRESIDENT_ID } from '../../constants';
import * as Utils from '../../utils';

const ContentsNav = ({ items, title }) => {
  items =
    items.filter((e) => !['front-cover', 'intro', 'scholars', 'back-cover'].includes(e?.id)) || [];
  const hasItems = !!items?.length;

  return (
    <div className='contents-nav'>
      <div className='container'>
        <div className='row'>
          <div className='col'>
            <div className='contents-nav__container'>
              {title && <div className='contents-nav__title'>{title}</div>}
              {hasItems && (
                <ul className='contents-nav__list'>
                  {items.map((item) => {
                    const childrens = item?.items || [];
                    const hasChildrens = !!childrens?.length;
                    const isExternal = !!item?.href;

                    if (isExternal) {
                      return (
                        <li
                          className='contents-nav__list-item'
                          key={`contents-nav__col-${item?.id}`}
                        >
                          <a
                            className='contents-nav__list-item-link'
                            href={item.href}
                            target='_blank'
                            rel='noreferrer'
                          >
                            <span dangerouslySetInnerHTML={{ __html: item?.title }} />
                            <ArrowRight className='contents-nav__list-item-icon' />
                          </a>
                        </li>
                      );
                    }

                    return (
                      <li className='contents-nav__list-item' key={`contents-nav__col-${item?.id}`}>
                        <a
                          className='contents-nav__list-item-link'
                          href={`#${item?.id}`}
                          onClick={() => Utils.handleScrollToSlide(item?.id)}
                        >
                          <span dangerouslySetInnerHTML={{ __html: item?.title }} />
                          <ArrowRight className='contents-nav__list-item-icon' />
                        </a>
                        {hasChildrens && (
                          <ul className='contents-nav__list'>
                            {childrens.map((child, childIndex) => {
                              return (
                                <li
                                  className='contents-nav__list-item'
                                  key={`contents-nav__list-item-${child?.id}`}
                                >
                                  <a
                                    className='contents-nav__list-item-link'
                                    href={`#${item?.id}-${childIndex}`}
                                    onClick={() => Utils.handleScrollToSlide(item?.id, childIndex)}
                                  >
                                    <span dangerouslySetInnerHTML={{ __html: child?.title }} />
                                    <ArrowRight className='contents-nav__list-item-icon' />
                                  </a>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </li>
                    );
                  })}
                </ul>
              )}
              <div className='contents-nav__cta'>
                <ScrollButton href={`#${LETTER_FROM_THE_PRESIDENT_ID}`} theme='dark' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ContentsNav.propTypes = {
  items: PropTypes.array,
  title: PropTypes.string,
};

export default ContentsNav;
